/**
 * Cross-tab logout propagation.
 *
 * Replaces the previous keycloak `checkLoginIframe` / `onAuthLogout` mechanism,
 * which relied on a third-party (cross-site) iframe to keycloak. Modern browsers
 * block third-party cookies, which made that iframe hang `keycloak.init()`
 */
const CHANNEL_NAME = 'lantern-assessment-auth';
const LOGOUT_MESSAGE = 'logout';
const STORAGE_KEY = 'lantern-assessment:remote-logout';

const isBroadcastChannelSupported = typeof BroadcastChannel !== 'undefined';

let channel = null;
const getChannel = () => {
    if (!isBroadcastChannelSupported) {
        return null;
    }
    if (channel === null) {
        channel = new BroadcastChannel(CHANNEL_NAME);
    }
    return channel;
};

export const broadcastLogout = () => {
    const activeChannel = getChannel();
    if (activeChannel) {
        activeChannel.postMessage(LOGOUT_MESSAGE);
        return;
    }
    try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
        // Storage may be unavailable (private mode / kiosk); nothing else to do.
    }
};

export const subscribeToRemoteLogout = onRemoteLogout => {
    const activeChannel = getChannel();
    if (activeChannel) {
        const handleMessage = event => {
            if (event.data === LOGOUT_MESSAGE) {
                onRemoteLogout();
            }
        };
        activeChannel.addEventListener('message', handleMessage);
        return () => activeChannel.removeEventListener('message', handleMessage);
    }
    const handleStorage = event => {
        if (event.key === STORAGE_KEY && event.newValue) {
            onRemoteLogout();
        }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
};
